import { render, staticRenderFns } from "./CompletedOrdersRoute.vue?vue&type=template&id=15a19272"
import script from "./CompletedOrdersRoute.vue?vue&type=script&lang=ts"
export * from "./CompletedOrdersRoute.vue?vue&type=script&lang=ts"
import style0 from "./CompletedOrdersRoute.vue?vue&type=style&index=0&id=15a19272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports